<template>
  <el-popover class="tap" placement="top-start" title="" width="350" trigger="hover" :content="inputObj.val">
    <div class="flex flex-wrap align-center justify-start" slot="reference">
      <div v-for="(item, index) in items" :key="index" @click="showProviewSuffix(index)">
        <suffix-icon  :suffix="item.suffix" :file="item" />
      </div>
    </div>
    <el-table :data="items" v-if="items && items.length>0" :show-header="false">
      <el-table-column width="50" property="url" label="">
        <template slot-scope="scope">
          <div @click="showProviewSuffix(scope.$index)" class="tap">
            <suffix-icon  :suffix="scope.row.suffix" :file="scope.row" />
          </div>
        </template>
      </el-table-column>
      <el-table-column width="300" property="name" label="">
        <template slot-scope="scope">
          <div @click="showProviewSuffix(scope.$index)" class="tap">{{scope.row.name}}</div>
        </template>
      </el-table-column>
    </el-table>
  </el-popover>
</template>

<script>
import suffixIcon from './suffix-icon.vue';
export default {
  components: {
    suffixIcon,
  },
  props: {
    inputObj: {
      type: Object,
      value: null
    },
  },
  data() {
    return {
      items: null,
    }
  },
  methods: {
    init() {
      if(!this.inputObj || !this.inputObj.val){
        return;
      }
      if(typeof this.inputObj.val == 'string'){
        this.items = JSON.parse(this.inputObj.val);
      }else{
        this.items = this.inputObj.val;
      }
      
    },
    showProviewSuffix(index){
      this.$emit('event', {items:this.items, index:index});
      //this.$refs.proviewSuffix.show(item);
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/card/customInputSuffix.vue